/** Restore page scroll after modals/menus lock the body. Safe to call repeatedly. */
export function releaseBodyScrollLock() {
  document.body.style.overflow = '';
  document.body.classList.remove('body-scroll-lock');
  if (document.body.style.top) {
    document.body.style.top = '';
  }
}

export function lockBodyScrollInline() {
  document.body.style.overflow = 'hidden';
}
